if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.querySelector('.media-prev').addEventListener('click', this.prev.bind(this, false));
      this.querySelector('.media-next').addEventListener('click', this.next.bind(this, false));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    prev() {
      const currentActive = this.querySelector(`.product-media-modal__content > .active`);
      const sibling = currentActive.previousElementSibling;
      if (sibling) {
        sibling.classList.add('active');
      } else {
        this.querySelector(`.product-media-modal__content > [data-media-id]:last-child`).classList.add('active');
      }
      currentActive.classList.remove('active');
    }

    next() {
      const currentActive = this.querySelector(`.product-media-modal__content > .active`);
      const sibling = currentActive.nextElementSibling;
      if (sibling) {
        sibling.classList.add('active');
      } else {
        this.querySelector(`.product-media-modal__content > [data-media-id]:first-child`).classList.add('active');
      }
      currentActive.classList.remove('active');
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
